import React, { useEffect, useState, useMemo, JSX } from 'react';
import '../CSS/Accordion.css';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import { Elements } from '@kontent-ai/delivery-sdk';
import Body from './Body';
import RichTextComponents from './RichTextComponents';

interface AccordionTypeProps {
  title?: string;
  accordionTypeStyling: string;
  body?: Elements.RichTextElement;
  linkedItems?: Elements.LinkedItemsElement | null;
}

const AccordionType: React.FC<AccordionTypeProps> = ({
  title,
  accordionTypeStyling,
  body,
  linkedItems,
}) => {
  // const [isExpanded, setExpanded] = useState(false);
  const [expandedIndex, setExpandedIndex] = useState<number | null>(null);
  const [accordionData, setAccordionData] = useState<any[]>([]);

  const colorMap: { [key: string]: string } = {
    accordion_type_standard: '#003370',
    accordion_type_cyu: '#29a7c1',
    accordion_type_ayk: '#c25a14',
    accordion_type_wdy: '#650964',
  };

  const accordionColor = colorMap[accordionTypeStyling] || '#000'; // Default to black if not found

  const iconColor = {
    color: accordionColor,
  };
  useEffect((): void => {
    const fetchAllAccordionData = async (): Promise<void> => {
      const fetchedAccordionData = [];
      if (linkedItems && linkedItems.linkedItems) {
        for (const item of linkedItems.linkedItems) {
          fetchedAccordionData.push({
            panel: item.elements.panel.value,
            accordion_content: item.elements.accordion_content,
            style: item.elements.accordion_type_styling,
          });
        }
      }
      setAccordionData(fetchedAccordionData);
    };

    fetchAllAccordionData();
  }, [linkedItems]);

  const memoizedAccordionData = useMemo(() => accordionData, [accordionData]);
  const renderContentByColor = (
    _color: string,
    _accordionData: any[],
  ): JSX.Element => {
    switch (accordionColor) {
      case '#003370':
        return (
          <div className="da-panel-primary">
            {title && <div className="da-title">{title}</div>}
            {body && <Body element={body} />}
            {memoizedAccordionData.map(
              (
                data: {
                  panel: string;
                  accordion_content: Elements.RichTextElement;
                  style: string;
                },
                index: number,
              ) => (
                <div key={index} className="panel-group accordion-panel-group ">
                  <div className="panel panel-primary accordion-panel-primary">
                    <Accordion
                      expanded={expandedIndex === index}
                      onChange={(): void =>
                        setExpandedIndex(expandedIndex === index ? null : index)
                      }
                      sx={{
                        '& .MuiAccordionSummary-root': {
                          padding: '0px 8px',
                        },
                        '& .MuiAccordionDetails-root': {
                          paddingTop: '0px',
                          paddingBottom: '0px',
                          // paddingLeft: '0px',
                          // paddingRight: '0px',
                        },

                        '& .MuiAccordionSummary-root.Mui-expanded': {
                          minHeight: '0px',
                        },

                        '& .MuiAccordionSummary-content': {
                          margin: '0px',
                          padding: '0px',
                        },
                      }}
                    >
                      <AccordionSummary
                        sx={{
                          '& .MuiAccordionSummary-expandIconWrapper': iconColor,

                          '& .MuiAccordionSummary-content': {
                            display: 'inline-block',
                            // marginTop: '0px' ,
                            // marginBottom: '0px' ,
                            // marginLeft: '7px',
                            // marginRight: '10px',
                            // paddingBottom: '0px',
                            // margin: '0px',
                          },

                          '& .MuiAccordionSummary-content.Mui-expanded': {
                            // display: 'inline-block',
                            // // marginTop: '0px' ,
                            // marginBottom: '0px' ,
                            // marginLeft: '7px',
                            // marginRight: '10px',
                            // paddingBottom: '0px',
                            margin: '0px',
                          },
                        }}
                        aria-controls="panel-content"
                        id="panel-header"
                      >
                        <div className="accordion-panel-heading">
                          <h4 className="accordion-panel-title">
                            <span
                              style={{
                                verticalAlign: 'middle',
                                display: 'inline-block',
                                width: '90%',
                              }}
                            >
                              {data.panel}
                            </span>
                            {expandedIndex === index ? (
                              <span
                                style={{
                                  width: '10%',
                                  verticalAlign: 'middle',
                                  textAlign: 'right',
                                }}
                                className="accordion-toggle glyphicon glyphicon-minus"
                              ></span>
                            ) : (
                              <span
                                style={{
                                  width: '10%',
                                  verticalAlign: 'middle',
                                  textAlign: 'right',
                                }}
                                className="accordion-toggle collapsed glyphicon glyphicon-plus"
                              ></span>
                            )}
                          </h4>
                        </div>
                      </AccordionSummary>
                      <AccordionDetails
                        className="accordion-panel-primary accordion-panel-body"
                        id="panel-content"
                        aria-labelledby="panel-header"
                        sx={{
                          '& .MuiAccordionDetails-root': {
                            padding: '0px',
                          },
                        }}
                      >
                        {expandedIndex === index ? (
                          <div className="panel-collapse collapse in">
                            <RichTextComponents
                              element={data.accordion_content}
                            />
                          </div>
                        ) : (
                          <div
                            className="panel-collapse collapse"
                            style={{ height: '10px' }}
                          ></div>
                        )}
                      </AccordionDetails>
                    </Accordion>
                  </div>
                </div>
              ),
            )}
          </div>
        );
      case '#29a7c1':
        return (
          <div className="row toolbox-content">
            <div className="col-md-12 CYU">
              <div className="CYU-group">
                {title && <h3 className="CYU">{title}</h3>}
                {body && <Body element={body} />}
                {memoizedAccordionData.map(
                  (
                    data: {
                      panel: string;
                      accordion_content: Elements.RichTextElement;
                      style: string;
                    },
                    index: number,
                  ) => (
                    <div key={index} className="panel-group cyu-panel-group ">
                      <div className="panel panel-primary cyu-panel-primary">
                        <Accordion
                          expanded={expandedIndex === index}
                          onChange={(): void =>
                            setExpandedIndex(
                              expandedIndex === index ? null : index,
                            )
                          }
                          sx={{
                            '& .MuiAccordionSummary-root': {
                              padding: '0px 8px',
                            },
                            '& .MuiAccordionDetails-root': {
                              paddingTop: '0px',
                              paddingBottom: '0px',
                              // paddingLeft: '0px',
                              // paddingRight: '0px',
                            },

                            '& .MuiAccordionSummary-root.Mui-expanded': {
                              minHeight: '0px',
                            },

                            '& .MuiAccordionSummary-content': {
                              margin: '0px',
                              padding: '0px',
                            },
                          }}
                        >
                          <AccordionSummary
                            sx={{
                              '& .MuiAccordionSummary-expandIconWrapper':
                                iconColor,

                              '& .MuiAccordionSummary-content': {
                                display: 'inline-block',
                                // marginTop: '0px' ,
                                // marginBottom: '0px' ,
                                // marginLeft: '7px',
                                // marginRight: '10px',
                                // paddingBottom: '0px',
                                // margin: '0px',
                              },

                              '& .MuiAccordionSummary-content.Mui-expanded': {
                                // display: 'inline-block',
                                // // marginTop: '0px' ,
                                // marginBottom: '0px' ,
                                // marginLeft: '7px',
                                // marginRight: '10px',
                                // paddingBottom: '0px',
                                margin: '0px',
                              },
                            }}
                            aria-controls="panel-content"
                            id="panel-header"
                          >
                            <div className="panel-wdyheading">
                              <h4 className="cyu-title">
                                <span
                                  style={{
                                    verticalAlign: 'middle',
                                    display: 'inline-block',
                                    width: '90%',
                                  }}
                                >
                                  <i>{data.panel}</i>
                                </span>
                                {expandedIndex === index ? (
                                  <span
                                    style={{
                                      width: '10%',
                                      verticalAlign: 'middle',
                                      textAlign: 'right',
                                    }}
                                    className="cyu-toggle glyphicon glyphicon-minus"
                                  ></span>
                                ) : (
                                  <span
                                    style={{
                                      width: '10%',
                                      verticalAlign: 'middle',
                                      textAlign: 'right',
                                    }}
                                    className="cyu-toggle collapsed glyphicon glyphicon-plus"
                                  ></span>
                                )}
                              </h4>
                            </div>
                          </AccordionSummary>
                          <AccordionDetails
                            className="cyu-panel-primary"
                            id="panel-content"
                            aria-labelledby="panel-header"
                            sx={{
                              '& .MuiAccordionDetails-root': {
                                padding: '0px',
                              },
                            }}
                          >
                            {expandedIndex === index ? (
                              <span className="panel-collapse CYUFeedback collapse in"></span>
                            ) : (
                              <span className="panel-collapse CYUFeedback collapse"></span>
                            )}
                            <span>
                              {data.accordion_content &&
                              data.accordion_content.value ? (
                                <RichTextComponents
                                  element={data.accordion_content}
                                />
                              ) : (
                                <div>No content available</div>
                              )}
                            </span>
                          </AccordionDetails>
                        </Accordion>
                      </div>
                    </div>
                  ),
                )}
              </div>
            </div>
          </div>
        );
      case '#c25a14':
        return (
          <div className="row toolbox-content">
            <div className="col-md-12 AYK">
              <div className="AYK-group">
                {title && <h3 className="AYK">{title}</h3>}
                {body && <Body element={body} />}
                {memoizedAccordionData.map(
                  (
                    data: {
                      panel: string;
                      accordion_content: Elements.RichTextElement;
                      style: string;
                    },
                    index: number,
                  ) => (
                    <div key={index} className="panel-group ayk-panel-group ">
                      <div className="panel panel-primary ayk-panel-primary">
                        <Accordion
                          expanded={expandedIndex === index}
                          onChange={(): void =>
                            setExpandedIndex(
                              expandedIndex === index ? null : index,
                            )
                          }
                          sx={{
                            '& .MuiAccordionSummary-root': {
                              padding: '0px 8px',
                            },
                            '& .MuiAccordionDetails-root': {
                              paddingTop: '0px',
                              paddingBottom: '0px',
                              // paddingLeft: '0px',
                              // paddingRight: '0px',
                            },

                            '& .MuiAccordionSummary-root.Mui-expanded': {
                              minHeight: '0px',
                            },

                            '& .MuiAccordionSummary-content': {
                              margin: '0px',
                              padding: '0px',
                            },
                          }}
                        >
                          <AccordionSummary
                            sx={{
                              '& .MuiAccordionSummary-expandIconWrapper':
                                iconColor,

                              '& .MuiAccordionSummary-content': {
                                display: 'inline-block',
                                // marginTop: '0px' ,
                                // marginBottom: '0px' ,
                                // marginLeft: '7px',
                                // marginRight: '10px',
                                // paddingBottom: '0px',
                                // margin: '0px',
                              },

                              '& .MuiAccordionSummary-content.Mui-expanded': {
                                // display: 'inline-block',
                                // // marginTop: '0px' ,
                                // marginBottom: '0px' ,
                                // marginLeft: '7px',
                                // marginRight: '10px',
                                // paddingBottom: '0px',
                                margin: '0px',
                              },
                            }}
                            aria-controls="panel-content"
                            id="panel-header"
                          >
                            <div className="panel-aykheading">
                              <h4 className="ayk-title">
                                <span
                                  style={{
                                    verticalAlign: 'middle',
                                    display: 'inline-block',
                                    width: '90%',
                                  }}
                                >
                                  <i>{data.panel}</i>
                                </span>
                                {expandedIndex === index ? (
                                  <span
                                    style={{
                                      width: '10%',
                                      verticalAlign: 'middle',
                                      textAlign: 'right',
                                    }}
                                    className="ayk-toggle glyphicon glyphicon-minus"
                                  ></span>
                                ) : (
                                  <span
                                    style={{
                                      width: '10%',
                                      verticalAlign: 'middle',
                                      textAlign: 'right',
                                    }}
                                    className="ayk-toggle collapsed glyphicon glyphicon-plus"
                                  ></span>
                                )}
                              </h4>
                            </div>
                          </AccordionSummary>
                          <AccordionDetails
                            className="ayk-panel-primary"
                            id="panel-content"
                            aria-labelledby="panel-header"
                            sx={{
                              '& .MuiAccordionDetails-root': {
                                padding: '0px',
                              },
                            }}
                          >
                            {expandedIndex === index ? (
                              <span className="panel-collapse AYKFeedback collapse in"></span>
                            ) : (
                              <span className="panel-collapse AYKFeedback collapse"></span>
                            )}
                            <span>
                              {data.accordion_content &&
                              data.accordion_content.value ? (
                                <RichTextComponents
                                  element={data.accordion_content}
                                />
                              ) : (
                                <div>No content available</div>
                              )}
                            </span>
                          </AccordionDetails>
                        </Accordion>
                      </div>
                    </div>
                  ),
                )}
              </div>
            </div>
          </div>
        );

      case '#650964':
        return (
          <div className="row toolbox-content">
            <div className="col-md-12 WDY">
              <div className="WDY-group">
                {title && <h3 className="WDY">{title}</h3>}
                {body && <Body element={body} />}
                {memoizedAccordionData.map(
                  (
                    data: {
                      panel: string;
                      accordion_content: Elements.RichTextElement;
                      style: string;
                    },
                    index: number,
                  ) => (
                    <div key={index} className="panel-group wdy-panel-group ">
                      <div className="panel panel-primary wdy-panel-primary">
                        <Accordion
                          expanded={expandedIndex === index}
                          onChange={(): void =>
                            setExpandedIndex(
                              expandedIndex === index ? null : index,
                            )
                          }
                          sx={{
                            '& .MuiAccordionSummary-root': {
                              padding: '0px 8px',
                            },
                            '& .MuiAccordionDetails-root': {
                              paddingTop: '0px',
                              paddingBottom: '0px',
                              // paddingLeft: '0px',
                              // paddingRight: '0px',
                            },

                            '& .MuiAccordionSummary-root.Mui-expanded': {
                              minHeight: '0px',
                            },

                            '& .MuiAccordionSummary-content': {
                              margin: '0px',
                              padding: '0px',
                            },
                          }}
                        >
                          <AccordionSummary
                            sx={{
                              '& .MuiAccordionSummary-expandIconWrapper':
                                iconColor,

                              '& .MuiAccordionSummary-content': {
                                display: 'inline-block',
                                // marginTop: '0px' ,
                                // marginBottom: '0px' ,
                                // marginLeft: '7px',
                                // marginRight: '10px',
                                // paddingBottom: '0px',
                                // margin: '0px',
                              },

                              '& .MuiAccordionSummary-content.Mui-expanded': {
                                // display: 'inline-block',
                                // // marginTop: '0px' ,
                                // marginBottom: '0px' ,
                                // marginLeft: '7px',
                                // marginRight: '10px',
                                // paddingBottom: '0px',
                                margin: '0px',
                              },
                            }}
                            aria-controls="panel-content"
                            id="panel-header"
                          >
                            <div className="panel-wdyheading">
                              <h4 className="wdy-title">
                                <span
                                  style={{
                                    verticalAlign: 'middle',
                                    display: 'inline-block',
                                    width: '90%',
                                  }}
                                >
                                  <i>{data.panel}</i>
                                </span>
                                {expandedIndex === index ? (
                                  <span
                                    style={{
                                      width: '10%',
                                      verticalAlign: 'middle',
                                      textAlign: 'right',
                                    }}
                                    className="wdy-toggle glyphicon glyphicon-minus"
                                  ></span>
                                ) : (
                                  <span
                                    style={{
                                      width: '10%',
                                      verticalAlign: 'middle',
                                      textAlign: 'right',
                                    }}
                                    className="wdy-toggle collapsed glyphicon glyphicon-plus"
                                  ></span>
                                )}
                              </h4>
                            </div>
                          </AccordionSummary>
                          <AccordionDetails
                            className="ayk-panel-primary"
                            id="panel-content"
                            aria-labelledby="panel-header"
                            sx={{
                              '& .MuiAccordionDetails-root': {
                                padding: '0px',
                              },
                            }}
                          >
                            {expandedIndex === index ? (
                              <span className="panel-collapse WDYFeedback collapse in"></span>
                            ) : (
                              <span className="panel-collapse WDYFeedback collapse"></span>
                            )}
                            <span>
                              {data.accordion_content &&
                              data.accordion_content.value ? (
                                <RichTextComponents
                                  element={data.accordion_content}
                                />
                              ) : (
                                <div>No content available</div>
                              )}
                            </span>
                          </AccordionDetails>
                        </Accordion>
                      </div>
                    </div>
                  ),
                )}
              </div>
            </div>
          </div>
        );
      default:
        return <div></div>;
    }
  };

  return <div>{renderContentByColor(accordionColor, accordionData)}</div>;
};

export default AccordionType;
